module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("协议")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('iframe', {
    ref: "frame",
    staticClass: "frame",
    attrs: {
      "src": _vm.protocolUrl,
      "frameborder": "0"
    }
  })], 1), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34e037a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/protocol.vue
// module id = 344
// module chunks = 1